import { InteractiveTable, InteractiveTableCellProps } from '@dreryk/react-components';

import { MedicalServicePractitionerDisplayName } from '../../practitioner.types';

type MedicalServicePractitionerDisplayNameCellProps = InteractiveTableCellProps<MedicalServicePractitionerDisplayName | null> & {
   readonly defaultValue: MedicalServicePractitionerDisplayName | null;
};

export const MedicalServicePractitionerDisplayNameCell = (
   props: MedicalServicePractitionerDisplayNameCellProps
): JSX.Element => {
   return (
      <InteractiveTable.TextViewCell
         testId={props.testId}
         name={props.name}
         index={props.index}
         defaultValue={props.defaultValue}
      />
   );
};
